import { render } from "./Habilidades.vue?vue&type=template&id=c02cacaa&scoped=true"
import script from "./Habilidades.vue?vue&type=script&lang=js"
export * from "./Habilidades.vue?vue&type=script&lang=js"

import "./Habilidades.vue?vue&type=style&index=0&id=c02cacaa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02cacaa"]])

export default __exports__